export const addresses = {
  "stabilityPool": "0x66017D22b0f8556afDd19FC67041899Eb65a21bb",
  "bammKeeper": "0xeaE019ef845A4Ffdb8829210De5D30aC6FbB5371"
}